module.exports = __webpack_public_path__ + "media/images/top/card-wedding-8811446abd6a4a638983bd66c169ea36.jpg";